var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{on:{"click":_vm.getTargetRoute}},[_c('feather-icon',{attrs:{"size":"21","icon":"CastIcon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }